import { Component, Input, Inject, ViewEncapsulation, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { CallerAddressModel } from '@models';
import { SocketConnection } from '@services/app/socket-io';
import { CallerServices } from '@services/app/caller.services';
import { AlertServices, AppServices } from '@services';

@Component({
  selector: 'app-cmp-caller',
  templateUrl: './cmp-caller.component.html',
  styleUrls: ['./cmp-caller.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class cmpCallerComponent {
  @ViewChild("PhoneIcon") _PhoneIcon: ElementRef;
  @Input() CallerInfo: CallerAddressModel;

  CallerDataForm: FormGroup = this.fb.group({}); //A. Register FormGroup

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    @Inject('SocketConnection') private _socket: SocketConnection,
    @Inject('CallerServices') private _callerServices: CallerServices,
    @Inject('AlertServices') private _alertServices: AlertServices,
    @Inject('AppServices') private _appServices: AppServices
  ) {

    //Temp Connection Until Develop Based on Project
    //For the moment no issue cause only epos is connected to the caller
    this._socket.Initialize_Socket_Connection()

    this.CallerDataForm = this.initDataForm() //B. Initialize Empty FormGroup Data


    this._socket.onIncomingCall.subscribe((_CallerInstance) => {

      //SAVE CALLER INFORMATION based on CallerGUID AND/OR CallerID
      console.log('Incoming Call on Caller')
      this.CallerInfo = _CallerInstance
      this.CallerDataForm = this.initDataForm(this.CallerInfo)

      let CallerFilter = new CallerAddressModel({})
      CallerFilter.Phone = _CallerInstance.Phone


      this._callerServices.FindCallerAddress(CallerFilter).pipe(takeUntil(this.unsubscribe)).subscribe((_response) => {

        if (_response.length > 0) {

          this.CallerDataForm.get("Name").setValue(_response[0]?.Contact);
          this.CallerDataForm.get("Surname").setValue(_response[0]?.Company);

          let _CallerAddressDataForm = <FormGroup>this.CallerDataForm.get('AddressForm')
          _CallerAddressDataForm.get("AddressID").setValue(_response[0]?.AddressID);
          _CallerAddressDataForm.get("AddressStreetID").setValue(_response[0]?.AddressStreetID);
          _CallerAddressDataForm.get("AddressTownID").setValue(_response[0]?.AddressTownID);
          _CallerAddressDataForm.get("District").setValue(_response[0]?.District);
          _CallerAddressDataForm.get("Number").setValue(_response[0]?.Number);
          _CallerAddressDataForm.get("PostCode").setValue(_response[0]?.PostCode);
          _CallerAddressDataForm.get("Street").setValue(_response[0]?.Street);
          _CallerAddressDataForm.get("Town").setValue(_response[0]?.Town);
          _CallerAddressDataForm.get("StreetLat").setValue(_response[0]?.StreetLat);
          _CallerAddressDataForm.get("StreetLng").setValue(_response[0]?.StreetLng);
          _CallerAddressDataForm.get("AddressLat").setValue(_response[0]?.AddressLat);
          _CallerAddressDataForm.get("AddressLng").setValue(_response[0]?.AddressLng);

          console.log(this.CallerDataForm.getRawValue())
        }


      }, (_error) => {

        console.log('error getting caller additional info')
      });

      //this.renderer.addClass(this._PhoneIcon.nativeElement, "PhoneIconAnimation");
      //this.renderer.removeClass(this._PhoneIcon.nativeElement, "d-none");


    });

    this._socket.onEndedCall.subscribe((_CallerInstance) => {
      console.log('Call Ended')
      console.log(_CallerInstance)
      console.log(this.CallerInfo)
      this.CallerInfo.CallStatus = _CallerInstance?.CallStatus;

      //UPDATE CALLER INFORMATION based on CallerGUID AND/OR CallerID



      //this.CallerInfo = new CallerAddressModel({})
      //this.CallerDataForm = this.initDataForm(this.CallerInfo)
      //console.log(this.CallerDataForm.getRawValue())


      //this.renderer.addClass(this._PhoneIcon.nativeElement, "PhoneIconAnimation");
      this.renderer.removeClass(this._PhoneIcon.nativeElement, "PhoneIconAnimation");

      // setTimeout(() => {
      //   this.CallerInfo = null;
      //   this.CallerDataForm = this.initDataForm()
      // }, 5500);


    });

    this._socket.onConnectedCall.subscribe((_CallerInstance) => {
      //UPDATE CALLER INFORMATION based on CallerGUID AND/OR CallerID
      this.CallerInfo.CallStatus = _CallerInstance.CallStatus;

      console.log('Call Answered')
      console.log(_CallerInstance)
      //this.CallerInfo = new CallerAddressModel({})
      //this.CallerDataForm = this.initDataForm(this.CallerInfo)
      //console.log(this.CallerDataForm.getRawValue())

    });



    //DELIVERY SECTION - NEW COMPONENT
    this._socket.onDeliveryCompleted.subscribe((_DeliveryInformation) => {

      let DeliveryInformation = JSON.parse(_DeliveryInformation)
      let _Contact = DeliveryInformation.Company || DeliveryInformation.Contact || ' UnDefined'

      console.log(_DeliveryInformation)

      let DeliveryInfo =
        `
        <div class='row'> 
        
        <div class='col-4 csp-fs-12'> 
        ` + DeliveryInformation.Phone + `
        </div> 

        <div class='col-8 csp-fs-12'> 
        ` + _Contact + `
        </div> 
        
        </div> 

        <div class='row'> 
        
        <div class='col-4 csp-fs-12'> 
        ` + DeliveryInformation.PostCode + `
        </div> 

        <div class='col-8 csp-fs-12'> 
        ` + DeliveryInformation.Town + `
        </div> 
        
        </div> 


        <div class='row'> 
        
        <div class='col-12 csp-fs-12'>
        <span class='pr-2'> 
        ` + DeliveryInformation.Number + `
        </span> 
        <span> 
        ` + DeliveryInformation.Street + `
        </span> 
        </div> 

         </div> 
        `

      //let DeliveryInfo = `<span class='h6'> ` + _Contact + ` -  ` + DeliveryInformation.Number + ` ` + DeliveryInformation.Street + ` - ` +  DeliveryInformation.Town + `</span> `

      this._appServices.isMobileAppAgent().subscribe((isMobile) => {
        if (!isMobile) {
          this._alertServices.ShowToastMessageDefault('info', 'DELIVERED BY : ' + DeliveryInformation.Username, DeliveryInfo, true, 25500)
        }
      });

    });


  }

  ngOnInit() { }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  initDataForm(_CallerInfo?: CallerAddressModel) {
    let NewfbGroup = this.fb.group({

      Phone: [_CallerInfo?.Phone],
      Name: [_CallerInfo?.Name],
      Surname: [_CallerInfo?.Surname],

      //  AddressNotes: [_CallerInfo?.],
      //  isCompany: [_CallerInfo?.isCompany],
      //  Company: [_CallerInfo?.Company],
      //  hasOffer: [_CallerInfo?.hasOffer],

      AddressForm: this.fb.group({
        AddressID: [_CallerInfo?.AddressForm?.AddressID],
        AddressTownID: [_CallerInfo?.AddressForm?.AddressTownID],
        District: [_CallerInfo?.AddressForm?.District],
        Town: [_CallerInfo?.AddressForm?.Town],
        AddressStreetID: [_CallerInfo?.AddressForm?.AddressStreetID],
        Street: [_CallerInfo?.AddressForm?.Street],
        StreetLat: [_CallerInfo?.AddressForm?.StreetLat],
        StreetLng: [_CallerInfo?.AddressForm?.StreetLng],
        Number: [_CallerInfo?.AddressForm?.Number],
        PostCode: [_CallerInfo?.AddressForm?.PostCode],
        AddressLat: [_CallerInfo?.AddressForm?.AddressLat],
        AddressLng: [_CallerInfo?.AddressForm?.AddressLng],
        isActive: [_CallerInfo?.AddressForm?.isActive],
      })

    });

    return NewfbGroup;
  }


  OnCallerClick() {
    this._socket.onCallerSelected.emit(this.CallerDataForm.getRawValue())
  }

  CloseCallerInfo() {
    this.CallerInfo = null;
    this.CallerDataForm = this.initDataForm()
  }


}